import { Link } from "react-router-dom";

const LINKS = [["/features", "Features"], ["/pricing", "Pricing"], ["/for-candidates", "For candidates"], ["/for-executives", "For executives"],
  ["/for-recruiters", "For recruiters"], ["/jobs", "Jobs by location"], ["/hourly-jobs", "Shift jobs"], ["/resume-ats-checker", "ATS resume check"], ["/partners", "Free jobs widget"], ["/faq", "FAQ"], ["/demo", "Book a demo"], ["/status", "System status"]];

export default function SiteFooter() {
  return (
    <footer className="border-t bg-white py-10" data-testid="site-footer">
      <nav className="mx-auto flex max-w-7xl flex-wrap justify-center gap-x-6 gap-y-2 px-4 text-sm" aria-label="Footer">
        {LINKS.map(([to, t]) => <Link key={to} to={to} className="text-slate-600 hover:text-slate-900" data-testid={`footer-link-${to.slice(1)}`}>{t}</Link>)}
      </nav>
      <p className="mt-6 text-center text-xs text-slate-500">© {new Date().getFullYear()} JobPedestal.com · contactus@jobpedestal.com</p>
    </footer>
  );
}
